import { render, staticRenderFns } from "./LayoutPublic.vue?vue&type=template&id=6c3776f8&scoped=true"
import script from "./LayoutPublic.vue?vue&type=script&lang=js"
export * from "./LayoutPublic.vue?vue&type=script&lang=js"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./LayoutPublic.vue?vue&type=style&index=1&id=6c3776f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3776f8",
  null
  
)

export default component.exports